import { useQueryClient } from '@tanstack/react-query'
import { Modal, ModalProps } from 'antd'
import { FormInstance } from 'antd/lib'

import { usePersonsServiceGetPersonListByDataEndpointKey } from 'src/api/queries'
import { useLocales } from 'src/locales'

import { PersonalDataSearch } from './PersonalDataSearch'

type Props = {
  onCancel: () => void
  form?: FormInstance
} & ModalProps

export const ContactsSection = ({ form, ...props }: Props) => {
  const { t } = useLocales()

  const queryClient = useQueryClient()

  const onCancel = () => {
    queryClient.removeQueries({
      queryKey: [usePersonsServiceGetPersonListByDataEndpointKey]
    })
    props.onCancel()
  }

  return (
    <Modal
      open
      width={900}
      maskClosable={false}
      title={t('persons.search_persons')}
      centered
      footer={false}
      onCancel={onCancel}
    >
      <PersonalDataSearch onCancel={onCancel} form={form} />
    </Modal>
  )
}
